<app-dropdown-option [disabled]="disabled">
  @if (loading) {
    <app-circle-loader class="w-6 h-6" [appearance]="'dark'"></app-circle-loader>
  } @else {
    <svg class="w-5 h-5" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="9.5" y1="2.50002" x2="9.5" y2="18.5" stroke="#04293E" stroke-linecap="round" stroke-linejoin="round" />
      <line x1="17.5" y1="10.5" x2="1.5" y2="10.5" stroke="#04293E" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    {{ value }} ({{ 'components.dropdowns.addOption.new' | translate }} {{ entityNameText }})
  }
</app-dropdown-option>
